import React from 'react';

export default function AuthorList({ authors, limit, searchKey, suffix = 'et al' }) {
    let list = authors.slice(0, limit || authors.length);
    limit && limit < authors.length && list.push(suffix);
    return <span className="author-list">{list.join(', ')}</span>;
}
